import { render, staticRenderFns } from "./FontFamily.vue?vue&type=template&id=8c3f3a12&"
import script from "./FontFamily.vue?vue&type=script&lang=ts&"
export * from "./FontFamily.vue?vue&type=script&lang=ts&"
import style0 from "./FontFamily.vue?vue&type=style&index=0&id=8c3f3a12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports